import request from '@/libs/http/index'

// 打印病历模版
export const printMedicalDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-medical/get`,
    params,
  })
}
export const printMedicalUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-medical/update`,
    data,
  })
}
export const printMedicalDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-medical/restore-default`,
    params,
  })
}
export const printMedicalSyncNameList = (params?: any) => {
  return request.get({
    url: `/clinic/print-medical/sync-name-list`,
    params,
  })
}

// 打印处方模版
export const printPrescriptionDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-prescription/get`,
    params,
  })
}
export const printPrescriptionUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-prescription/update`,
    data,
  })
}
export const printPrescriptionDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-prescription/restore-default`,
    params,
  })
}
export const printPrescriptionSyncNameList = (params?: any) => {
  return request.get({
    url: `/clinic/print-medical/sync-name-list`,
    params,
  })
}

// 打印治疗模版
export const printTreatmentDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-treatment/get`,
    params,
  })
}
export const printTreatmentUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-treatment/update`,
    data,
  })
}
export const printTreatmentDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-treatment/restore-default`,
    params,
  })
}
export const printTreatmentSyncNameList = (params?: any) => {
  return request.get({
    url: `/clinic/print-medical/sync-name-list`,
    params,
  })
}

// 打印收费小票模版
export const printRestoreDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-receipt/get`,
    params,
  })
}
export const printRestoreUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-receipt/update`,
    data,
  })
}
export const printRestoreDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-receipt/restore-default`,
    params,
  })
}
export const printRestoreSyncName = (params?: any) => {
  return request.get({
    url: `/clinic/print-receipt/sync-name`,
    params,
  })
}

// 打印发药小票模版
export const printDispensingDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-dispensing/get`,
    params,
  })
}
export const printDispensingUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-dispensing/update`,
    data,
  })
}
export const printDispensingDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-dispensing/restore-default`,
    params,
  })
}
export const printDispensingSyncName = (params?: any) => {
  return request.get({
    url: `/clinic/print-dispensing/sync-name`,
    params,
  })
}

// 打印挂号小票模版
export const printRegistrationReceiptDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-registration-receipt/get`,
    params,
  })
}
export const printRegistrationReceiptUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-registration-receipt/update`,
    data,
  })
}
export const printRegistrationReceiptDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-registration-receipt/restore-default`,
    params,
  })
}

// 打印用药标签模版
export const printDrugDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-drug/get`,
    params,
  })
}
export const printDrugUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-drug/update`,
    data,
  })
}
export const printDrugDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-drug/restore-default`,
    params,
  })
}

// 打印患者标签模版
export const printPatientDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-patient/get`,
    params,
  })
}
export const printPatientUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-patient/update`,
    data,
  })
}
export const printPatientDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-patient/restore-default`,
    params,
  })
}

// 打印诊断证明书模版
export const printDiagnosisCertificateDetail = (params?: any) => {
  return request.get({
    url: `/clinic/print-diagnosis-certificate/get`,
    params,
  })
}
export const printDiagnosisCertificateUpdate = (data: any) => {
  return request.put({
    url: `/clinic/print-diagnosis-certificate/update`,
    data,
  })
}
export const printDiagnosisCertificateDefault = (params?: any) => {
  return request.get({
    url: `/clinic/print-diagnosis-certificate/restore-default`,
    params,
  })
}
